import { TextField, TextFieldProps } from "@mui/material"
import { FieldValues, Path, UseFormRegister } from "react-hook-form"

type FormTextFieldProps<T extends FieldValues> = {
    name: Path<T>;
    label: string;
    register: UseFormRegister<T>;
    errorMessage?: string;
} & Omit<TextFieldProps, "name">;

export function FormTextField<T extends FieldValues>({
    name,
    label,
    register,
    errorMessage,
    ...rest
}: FormTextFieldProps<T>) {

    return <TextField
        label={label}
        {...register(name)}
        error={!!errorMessage}
        helperText={errorMessage}
        fullWidth
        slotProps={{
            inputLabel: {
                shrink: true,
            },
            htmlInput: {
                step: 'any',
            }
        }}
        {...rest}
    />
}